import React, { useState } from "react";
import ActionLink from "../components/ActionLink";

const CopyLink = ({ defaultText, copiedText, textToCopy, width }) => {
    const [linkText, setLinkText] = useState(defaultText);

    const handleClick = () => {
        setLinkText(copiedText);
        navigator.clipboard.writeText(textToCopy);
        setTimeout(() => {
            setLinkText(defaultText);
        }, 3000);
    };

    return (
        <div style={{width: width}} >
        <ActionLink 
            label={linkText} 
            className='copy mdi mdi-content-copy'
            handleClick={handleClick}
        />        
        </div>
    );
};

CopyLink.defaultProps = {
    defaultText: "Kopiuj",
    copiedText: "Skopiowano",
    width: '100px',
};


export default CopyLink;